<div class="text-left pointer-events-none">
      <div>
        <ng-template #customCurrencyOption let-currencyItem>

            <span class="d-inline-flex gap-2">
              <span [innerHTML]="renderCurrencyListItem(currencyItem) | safeHtml"></span>
            </span>

        </ng-template>
        <ng-template #customCurrencySelectedOption>
          <span class="d-inline-flex gap-2">
            <span [innerHTML]="renderSelectedCurrencyItem(selectedAccount) | safeHtml"></span>
          </span>
        </ng-template>

        <finxone-select-dropdown
          id="multi-currency-dropdown"
          formControlName="multiCurrencyCode`"
          [options]="dropdownListing"
          [customOptionTemplate]="customCurrencyOption"
          [customSelectedOptionTemplate]="customCurrencySelectedOption"
          [optionLabelKey]="'currency'"
          [optionValueKey]="'currency'"
          [appendToBody]="true"
          [searchEnabled]="isSearchEnabled"
          [selectedOption]="selectedMultiCurrencyAccount?.currency_code ?? ''"
          (selectionChange)="onCurrencyChange($event)"
          [label]="widgetProperties?.inputLabel ?? ''"
        >
        </finxone-select-dropdown>
      </div>
</div>
